import { render, staticRenderFns } from "./RobotArticle.vue?vue&type=template&id=16cab1b6&scoped=true&"
import script from "./RobotArticle.vue?vue&type=script&lang=js&"
export * from "./RobotArticle.vue?vue&type=script&lang=js&"
import style0 from "./RobotArticle.vue?vue&type=style&index=0&id=16cab1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cab1b6",
  null
  
)

export default component.exports